import useOnInlineCommentPopupOpen from './useOnInlineCommentPopupOpen';

export default useOnInlineCommentPopupOpen;